import { jsx as _jsx } from "react/jsx-runtime";
import { NotificationFront } from "notifications/ui";
import { useRef } from "react";
var NotificationCard = function (_a) {
    var notificationList = _a.notificationList, handleOnClick = _a.handleOnClick;
    var focusRef = useRef(null);
    return (_jsx(NotificationFront, { "data-test": "notifications-front", notificationList: notificationList !== null && notificationList !== void 0 ? notificationList : [], handleOnClick: handleOnClick, ref: focusRef }));
};
export default NotificationCard;
//# sourceMappingURL=NotificationCard.js.map